import React, { useState } from 'react';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';

const EmojiPicker = ({ value, onChange, label }) => {
  const [showPicker, setShowPicker] = useState(false);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, position: 'relative' }}>
      {label && <span style={{ minWidth: 70 }}>{label}</span>}
      <button
        type="button"
        onClick={() => setShowPicker(v => !v)}
        style={{
          fontSize: 22,
          border: '1.5px solid #ddd',
          borderRadius: 8,
          background: '#fff',
          width: 38,
          height: 38,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        title="Chọn emoji"
      >
        {value || '😀'}
      </button>
      {showPicker && (
        <div style={{ position: 'absolute', zIndex: 9999, top: 44, left: 0 }}>
          <Picker
            data={data}
            onEmojiSelect={emoji => {
              onChange(emoji.native);
              setShowPicker(false);
            }}
            previewPosition="none"
            skinTonePosition="none"
            searchPosition="sticky"
            style={{ width: 320 }}
          />
        </div>
      )}
    </div>
  );
};

export default EmojiPicker; 